<template>
  <div class="min-w-[700px]">
    <!--    {{ originalData }}-->
    <hi-form :initial-values="originalData" @submit="submit">
      <hi-form-item label="Phone">
        <hi-input
          form-key="phone"
          :validator="
            uniqueValueValidator(dbPaths.entities, 'phone', {
              byPassValue: originalData.phone,
            })
          "
        />
      </hi-form-item>
      <hi-form-item label="Email">
        <hi-input
          form-key="email"
          email
          :validator="
            uniqueValueValidator(dbPaths.entities, 'email', {
              byPassValue: originalData.email,
            })
          "
        />
      </hi-form-item>
      <hi-form-item label="Address">
        <hi-input-address form-key="address" />
      </hi-form-item>
      <hi-form-item label="Postal Address">
        <hi-input-address form-key="addressPostal" />
      </hi-form-item>
    </hi-form>
  </div>
</template>

<script>
import HiForm from "@/hive-vue3/components/form/HiForm";
import HiFormItem from "@/hive-vue3/components/form/HiFormItem";
import HiInput from "@/hive-vue3/components/form/controls/HiInput";
import HiInputAddress from "@/hive-vue3/components/form/controls/HiInputAddress";
import {
  firestoreDoc,
  uniqueDbValueValidator,
  updateFirestoreDoc,
} from "@/hive-vue3/firebase";
import dbPaths from "@/hive-vue3/modules/contacts/dbPaths";
export default {
  name: "ContactsEntityContactInfoEditor",
  props: {
    //none reactive after mounted
    originalData: Object,
  },
  components: { HiInputAddress, HiInput, HiFormItem, HiForm },
  emits: ["successful"],
  setup(props, { emit }) {
    async function submit(data) {
      // console.log(data);
      await updateFirestoreDoc(
        firestoreDoc(dbPaths.entities, props.originalData.id),
        data
      );
      emit("successful");
    }
    return {
      dbPaths,
      uniqueValueValidator: uniqueDbValueValidator,
      submit,
    };
  },
};
</script>

<style scoped></style>
